/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {ObjectDefinition} from './object-definition';
import {LocationInstance} from './location-instance';
import {ZoneInstance} from './zone-instance';
import {Point} from './point';

export class ObjectInstance extends BaseInstance {
  object: ObjectDefinition;
  locationInstance: LocationInstance;
  zoneInstance: ZoneInstance;
  position: Point;
  perimeterRadius: number;
}
